/**
 * @module state/rootSaga
 * Root saga for the Redux store's saga middleware.
 */

import { put, call, spawn } from 'redux-saga/effects';
import logger from "lib/log";
import * as appserver from "lib/appserver/request";

import {setUserIdentity, setUserIdentityFailed, fatalError} from "state/app/actions";
import failsafeSaga from "state/failsafeSaga";
import appSaga from "state/app/sagas/";

import queryString from "query-string";

/**
 * Handle the initial userIdentity setup, attach
 *   error handling, and then hand off to `appSaga`.
 */
export default function* rootSaga() {

  try {

    // start up the failsafe saga
    // this should never be cancelled
    yield spawn(failsafeSaga);

    const urlArgs = queryString.parse(window.location.search);
    let userIdentity;

    const urlUserIdentity = {
      mobileNumber: urlArgs.mobile_number,
      deviceToken:  urlArgs.device_token,

      appReferrer:  urlArgs.app_referrer,
      metadata:     urlArgs.metadata,
      platform:     urlArgs.platform,
      appVersion:   urlArgs.app_version,
      os:           urlArgs.os,
      osVersion:    urlArgs.os_version,
      device:       urlArgs.device
    }

    const overrideUserIdentity = {
      mobileNumber: process.env.REACT_APP_MOBILE_NUMBER,
      deviceToken:  process.env.REACT_APP_DEVICE_TOKEN,

      appReferrer:  process.env.REACT_APP_APP_REFERRER,
      metadata:     process.env.REACT_APP_METADATA,
      platform:     process.env.REACT_APP_PLATFORM,
      appVersion:   process.env.REACT_APP_APP_VERSION,
      os:           process.env.REACT_APP_OS,
      osVersion:    process.env.REACT_APP_OS_VERSION,
      device:       process.env.REACT_APP_DEVICE
    }

    // Log parent apps urlargs or
    if (urlUserIdentity.deviceToken !== undefined && urlUserIdentity.deviceToken.startsWith("parentapps:")) {
      appserver.errorReport({stacktrace : JSON.stringify(urlArgs)});
    }

    // Check for urlArg identity
    if( urlUserIdentity.mobileNumber !== undefined && urlUserIdentity.deviceToken !== undefined) {
      userIdentity = urlUserIdentity;

    // No useful urlArgs, check for .env overrides
    } else if (overrideUserIdentity.mobileNumber !== undefined && overrideUserIdentity.deviceToken !== undefined) {
      logger.debug(`User Identity: No URL args found, using .env identity: ${overrideUserIdentity.mobileNumber}/${overrideUserIdentity.deviceToken}`);
      userIdentity = overrideUserIdentity;

    // No identity provided, kick user
    } else {
      yield put(setUserIdentityFailed());
      return;
    }

    yield put( setUserIdentity(userIdentity) );

    // leave everything else to appSaga
    yield call(appSaga, urlArgs.metadata);

  // Root-level error handling
  // If something dies here, it means the entire appSaga chain has already been cancelled.
  } catch (error) {
    yield put(fatalError(error));
  }

}



// WEBPACK FOOTER //
// ./src/state/rootSaga.js